import { getApiClient } from "@punchup/utils";

export interface ComedianStripeStatusData {
  hasStripeAccount: boolean;
  hasSubscriptionProduct: boolean;
}

export async function getComedianStripeStatus(
  comedianId: string
): Promise<ComedianStripeStatusData> {
  return getApiClient()
    .get<{ data: ComedianStripeStatusData }>(
      `/api/v2/manager/stripe/status?comedian_id=${comedianId}`
    )
    .then((res) => res.data);
}

export async function initiateStripeOnboarding(
  comedianId: string,
  returnUrl: string
): Promise<{ redirectURL: string }> {
  return getApiClient().post<{ redirectURL: string }>("/api/onboardUser", {
    comedianId,
    returnUrl,
  });
}

export async function createComedianSubscription(
  comedianId: string,
  name: string,
  priceInCents: number,
  options?: {
    tier?: number;
    description?: string | null;
    descriptionDetailsBullets?: string[] | null;
  }
): Promise<{ id: string; price_id: string }> {
  return getApiClient()
    .post<{ data: { id: string; price_id: string } }>(
      "/api/v2/manager/subscriptions",
      {
        comedianId,
        name,
        priceInCents,
        tier: options?.tier,
        description: options?.description,
        descriptionDetailsBullets: options?.descriptionDetailsBullets,
      }
    )
    .then((res) => res.data);
}
